<div class="cms-shell">
  <app-sidebar></app-sidebar>
  <div class="relative min-h-screen bg-blueGray-100 lg:ml-64">
    <app-header-stats></app-header-stats>

    <div class="mx-auto mt-0 w-full px-3 pb-8 sm:px-4 lg:px-10">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </div>
</div>
